import styled from 'styled-components';
import { maxWidth } from 'config/constants';

export const StyledPublicFooter = styled.div`
  flex: 0 0;
  padding: 0;
  background-color: ${(props): string => props.theme.kcc.colors.WHITE};

  font-family: ${(props): string => props.theme.kcc.typography.FONT_FAMILY};
  font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.SM}px;
  line-height: ${(props): string => props.theme.kcc.spacing.LG};
  color: ${(props): string => props.theme.kcc.colors.BLACK};

  .footer__banner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${(props): string => props.theme.kcc.spacing.XS};
    padding: ${(props): string => props.theme.kcc.spacing.SM} ${(props): string => props.theme.kcc.spacing.BASE};
    background-color: var(--primary);
    flex-wrap: wrap;
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.BASE}px;
  }

  .footer__banner-title {
    font-weight: 700;
  }

  .footer__bottom {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: ${(props): string => props.theme.kcc.spacing.XS};
    padding: ${(props): string => props.theme.kcc.spacing.BASE} ${(props): string => props.theme.kcc.spacing.XXL};
  }

  .footer__legal-links {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
  }

  .footer__copyright {
    color: ${(props): string => props.theme.kcc.colors.TEXT_PLACEHOLDER};
  }

  .footer__legal-link {
    display: flex;
    align-items: center;

    &::after {
      content: '|';
      margin: 0 ${(props): string => props.theme.kcc.spacing.XS};
      color: ${(props): string => props.theme.kcc.colors.BLACK};
    }

    &--last::after,
    &:last-child::after {
      display: none;
    }
  }

  a {
    color: ${(props): string => props.theme.kcc.colors.BLACK};
    text-decoration: none;

    :hover,
    :focus,
    :active {
      color: ${(props): string => props.theme.kcc.colors.BLACK};
      text-decoration: underline;
    }
  }

  ${maxWidth.l} {
    .footer__banner {
      padding: 14px 36px;
    }

    .footer__bottom {
      padding: 23px 36px;
    }
  }

  ${maxWidth.s} {
    .footer__banner {
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 0;
      padding: 12px 23px;
    }

    .footer__bottom {
      padding: ${(props): string => props.theme.kcc.spacing.BASE} ${(props): string => props.theme.kcc.spacing.LG};
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;
